import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button, I } from '@leanin/ui';
import { FlowShell, type FlowStep } from '@/components/onboarding/FlowShell';
import { ChecklistColumn } from '@/components/onboarding/ChecklistColumn';
import { useOnboardingProgress } from '@/components/onboarding/progress';
import { useFinishOnboarding } from '@/components/onboarding/finish-onboarding';
import {
  STEP_CONTENT_BY_KEY,
  patchChecklistHref,
} from '@/components/onboarding/checklist-registry';
import { PERSONA_STEP_KEYS } from '@/components/onboarding/persona-steps';

const STEPS: ReadonlyArray<FlowStep> = [
  { label: 'Welcome' },
  { label: "Your Circle's page" },
  { label: "You're in" },
];

export const Route = createFileRoute('/onboarding/cl/complete')({
  component: CLOnboardingCompletePage,
});

function CLOnboardingCompletePage() {
  const navigate = useNavigate();
  const finish = useFinishOnboarding('cl');
  const { data: progress } = useOnboardingProgress();

  const circleChecklist = PERSONA_STEP_KEYS['circle-leader'].map((key) => {
    const content = STEP_CONTENT_BY_KEY[key];
    const href = progress
      ? patchChecklistHref(key, content.href, progress)
      : content.href;
    return { title: content.title, sub: content.sub, cta: content.cta, href };
  });

  return (
    <FlowShell
      role="Circle Leader"
      stepIndex={2}
      steps={STEPS}
      title="Explore your community."
      primary={
        <Button variant="primary" icon={I.arrow} onClick={() => void finish()}>
          Finish onboarding
        </Button>
      }
      secondary={
        <Button
          variant="ghost"
          onClick={() => navigate({ to: '/onboarding/cl/welcome' })}
        >
          Return to welcome message
        </Button>
      }
    >
      <ChecklistColumn
        eyebrow="Next steps"
        title="Your Circle Checklist"
        items={circleChecklist}
        onNavigate={(href) => void finish(href)}
      />
    </FlowShell>
  );
}
